// extracted by mini-css-extract-plugin
export default {"wrapper":"VipCustomers_wrapper__XGDI6","stats":"VipCustomers_stats__VRqEG","text-yellow":"VipCustomers_text-yellow__Ouft2"};